<template>
  <pt-life-experience-finance-audit class="pt-life-experience-finance-audit__page"></pt-life-experience-finance-audit>
</template>

<script>
import PtLifeExperienceFinanceAudit from 'cps/appointment-application/pt-life-experience-finance-audit/withData'
export default {
  name: 'pt-life-experience-finance-audit__view',
  components: {
    'pt-life-experience-finance-audit': PtLifeExperienceFinanceAudit
  }
}
</script>
